module.exports = __webpack_public_path__ + "Roboto-Medium.574fd0b50367f886d359.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Medium.woff2
// module id = 465
// module chunks = 2